import { render, staticRenderFns } from "./BIcon.vue?vue&type=template&id=37bc3bac&scoped=true&"
import script from "./BIcon.vue?vue&type=script&lang=ts&"
export * from "./BIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BIcon.vue?vue&type=style&index=0&id=37bc3bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc3bac",
  null
  
)

export default component.exports